import {DimensionAggregationModel, MeasureAggregationModel} from './aggregation_model';

export const GROUP_BY = new DimensionAggregationModel('Group by');

export const ALL = new MeasureAggregationModel('All rows of');
export const COUNT = new MeasureAggregationModel('# of All', ['count', 'number'], column => `COUNT(${column.sqlName})`);
export const COUNT_UNIQUE = new MeasureAggregationModel('# of Distinct', ['count', 'number'], column => `COUNT(DISTINCT ${column.sqlName})`);
export const TOTAL = new MeasureAggregationModel('Sum', ['sum'], column => `SUM(${column.sqlName})`);
export const AVG = new MeasureAggregationModel('Avg', ['average'], column => `AVG(${column.sqlName})`);
export const MIN = new MeasureAggregationModel('Min', ['minimum'], column => `MIN(${column.sqlName})`);
export const MAX = new MeasureAggregationModel('Max', ['maximum'], column => `MAX(${column.sqlName})`);
export const STD_DEV = new MeasureAggregationModel('STDev of', ['standard deviation'], column => `STDDEV(${column.sqlName})`);
export const VAR = new MeasureAggregationModel('Var of', ['variance'], column => `VARIANCE(${column.sqlName})`);

export const SECOND = new DimensionAggregationModel('Second of');
export const MINUTE = new DimensionAggregationModel('Minute of');
export const HOUR = new DimensionAggregationModel('Hour of');
export const DAY = new DimensionAggregationModel('Day of');
export const WEEK = new DimensionAggregationModel('Week of');
export const MONTH = new DimensionAggregationModel('Month of');
export const QUARTER = new DimensionAggregationModel('Quarter of');
export const YEAR = new DimensionAggregationModel('Year of');
export const HOUR_OF_DAY = new DimensionAggregationModel('Hour of Day');
export const DAY_OF_WEEK = new DimensionAggregationModel('Day of Week');
export const DAY_OF_MONTH = new DimensionAggregationModel('Day of Month');
export const DAY_OF_YEAR = new DimensionAggregationModel('Day of Year');
export const MONTH_OF_YEAR = new DimensionAggregationModel('Month of Year');

export const NUMBER_AGGREGATIONS = [ALL, COUNT_UNIQUE, COUNT, TOTAL, AVG, MIN, MAX /*, STD_DEV, VAR*/];
export const STRING_AGGREGATIONS = [ALL, COUNT_UNIQUE, COUNT];
export const DATE_MEASURE_AGGREGATIONS = NUMBER_AGGREGATIONS;

export const DATE_CONTINUOUS_AGGREGATIONS = [SECOND, MINUTE, HOUR, DAY, WEEK, MONTH, QUARTER, YEAR];
export const DATE_PERIODIC_AGGREGATIONS = [HOUR_OF_DAY, DAY_OF_WEEK, DAY_OF_MONTH, DAY_OF_YEAR, MONTH_OF_YEAR];

export const MEASURE_AGGREGATIONS = {
    number: NUMBER_AGGREGATIONS,
    string: STRING_AGGREGATIONS,
    date: DATE_MEASURE_AGGREGATIONS,
};

export const DIMENSION_AGGREGATIONS = {
    number: [GROUP_BY],
    string: [GROUP_BY],
    date: DATE_CONTINUOUS_AGGREGATIONS.concat(DATE_PERIODIC_AGGREGATIONS),
};

export const DEFAULT_MEASURE_AGGREGATION = {
    number: TOTAL,
    string: COUNT_UNIQUE,
    date: COUNT_UNIQUE,
    pk: COUNT_UNIQUE,
};
